// TODO: Lodash should no longer be used here
// eslint-disable-next-line no-restricted-imports
import _ from 'lodash';
import {
  addOrganizationLocation,
  organizationLocationsOnListen,
  updateOrganizationLocation,
} from '../../api/firebase/locations';
import { getUsersRoomsOrLocations } from '../helpers/getUsersRoomsOrLocations';
import store from '../store';
import {
  LOCATIONS_FETCHED,
  LOCATIONS_LISTENER_STARTED,
  LOCATION_ADDED,
  LOCATION_SELECTED,
  LOCATION_SELECTION_CLEARED,
  LOCATION_UPDATED,
} from './types';

export const locationsListenerStarted = () => ({
  type: LOCATIONS_LISTENER_STARTED,
});

export const locationsFetched = (locations) => ({
  type: LOCATIONS_FETCHED,
  locations,
});

export const locationAdded = (location) => ({
  type: LOCATION_ADDED,
  location,
});

export const locationUpdated = () => ({
  type: LOCATION_UPDATED,
});

export const locationSelected = (location) => ({
  type: LOCATION_SELECTED,
  location,
});

export const locationSelectionCleared = () => ({
  type: LOCATION_SELECTION_CLEARED,
});

export const getLocations = () => {
  const locations = store.getState().locations.list;
  if (_.isEmpty(locations)) return null;
  return locations || null;
};

export const startOrganizationLocationsListener = (organizationId) => (dispatch) => {
  dispatch(locationsListenerStarted());
  const validLocationIds = getUsersRoomsOrLocations('locations', organizationId);
  if (validLocationIds === null) {
    return () => {};
  }

  return organizationLocationsOnListen(
    { organizationId, validLocationIds },
    (data) => {
      if (data) dispatch(locationsFetched(data));
    },
    (error) => console.log('organizationLocationsOnListen error', error.message)
  );
};

export const organizationAddLocation =
  (organizationId, locationData, programType = null) =>
  (dispatch) =>
    addOrganizationLocation(organizationId, locationData, programType).then((location) =>
      dispatch(locationAdded(location))
    );

export const organizationUpdateLocation = (organizationId, locationData) => (dispatch) =>
  updateOrganizationLocation(organizationId, locationData).then((_location) => dispatch(locationUpdated()));
